import React, { type ComponentType } from 'react';
import type { Props as KeyboardShortcutsDialogProps } from '@atlassian/jira-common-components-keyboard-shortcuts-dialog/src/index.tsx';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const KeyboardShortcutsDialogLazy = lazy<ComponentType<KeyboardShortcutsDialogProps>>(
	() =>
		import(
			/* webpackChunkName: "atlassian-jira-keyboard-shortcuts.dialog" */ '@atlassian/jira-common-components-keyboard-shortcuts-dialog'
		),
	{ ssr: false },
);

export const KeyboardShortcutsDialog = (props: KeyboardShortcutsDialogProps) => (
	<JSErrorBoundary
		id="integrations.keyboard-shortcuts-dialog"
		packageName="jira-keyboard-shortcuts"
		fallback="unmount"
	>
		<Placeholder name="keyboard-shortcuts.dialog" fallback={null}>
			<KeyboardShortcutsDialogLazy {...props} />
		</Placeholder>
	</JSErrorBoundary>
);
